import { IRecommendation } from "../interfaces/models";
import RecommendationRepository from "../repositories/RecommendationRepository";

export default class RecommendationService {

    static findRecommendations(): Promise<IRecommendation[]> {
        return RecommendationRepository.findRecommendations();
    }

    static pendingRecommendations(): Promise<IRecommendation[]> {
        return RecommendationRepository.pendingRecommendations();
    }

    static reviewRecommendations(): Promise<IRecommendation[]> {
        return RecommendationRepository.reviewRecommendations();
    }

    static updateUserStatus(id: number, status: string, location: string | undefined) {
        return RecommendationRepository.updateUserStatus(id, status, location);
    }

    static updateReviewStatus(id: number, status: string) {
        return RecommendationRepository.updateReviewStatus(id, status);
    }

    static recommendStudySessions(): Promise<IRecommendation[]> {
        return RecommendationRepository.recommendStudySessions();
    }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/services/RecommendationService.ts